// A counterparty's legal review on its profile (TX-US-0042). Legal writes it at any status and
// saves it against the version read; everyone else reads it. Conditions held when Legal approves
// make the approval one with conditions.

import { getLegalReview, saveLegalReview } from '../../api.js';
import SheetPanel from '../sheets/SheetPanel.jsx';
import * as kit from './sheet.js';

const COPY = {
  heading: 'Legal review',
  preparedBy: 'Reviewed by',
  save: 'Save legal review',
  saved: 'Legal review saved.',
  coreKind: null,
  keeps: '',
  stale: 'This review changed since you opened it. Reload to see the current version.',
};

export default function LegalReview({ counterpartyId, canEdit }) {
  return (
    <SheetPanel id="legal-review" counterpartyId={counterpartyId} canEdit={canEdit}
                load={getLegalReview} save={saveLegalReview} kit={kit} copy={COPY} />
  );
}
